import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { ToastContainer, toast } from 'react-toastify';
import { injectIntl } from 'react-intl';

function CustomToast({ intl }) {
  const history = useHistory();
  const { unreadTicketsCount } = useSelector((state) => state.webmaster);

  const SECONDS_IN_24_HRS = 86400;

  useEffect(() => {
    const lastTimeClosed = localStorage.getItem('unread_tickets_toast_ts');

    if (
      unreadTicketsCount > 0 &&
      ((lastTimeClosed &&
        Date.now() / 1000 - parseInt(lastTimeClosed, 10) / 1000 > SECONDS_IN_24_HRS) ||
        !lastTimeClosed)
    ) {
      toast.dismiss();
      toast.error(
        `${intl.formatMessage({
          id: 'custom-toast.unread-massages',
          defaultMessage: 'Unread tickets:',
        })} ${unreadTicketsCount}`,
        {
          position: window.innerWidth > 768 ? 'bottom-center' : 'top-center',
          autoClose: false,
          hideProgressBar: true,
          closeOnClick: true,
          draggable: false,
          className: 'custom-toast',
          onClick: handleClick,
          onClose: () => localStorage.setItem('unread_tickets_toast_ts', Date.now()),
          closeButton: <span className="custom-toast__close" />,
        },
      );
    }
  }, [unreadTicketsCount]);

  function handleClick() {
    history.push('/tickets');
  }

  return <ToastContainer />;
}

export default injectIntl(CustomToast);
